import {
  deriveGenome,
  initialState,
  personality,
  stateHash,
  step,
} from 'yuragi-engine/fluctuation';
import type { PersonalityProfile } from '../game/types';

export interface YuragiCharacterProfile {
  personality: PersonalityProfile;
  stateHash: string;
}

export function buildCharacterProfile(identity: string, tick: number): YuragiCharacterProfile {
  const genome = deriveGenome(identity);
  let state = initialState(genome);
  for (let index = 0; index < tick; index += 1) {
    state = step(genome, state);
  }

  return {
    personality: personality(genome, state),
    stateHash: stateHash(genome, state),
  };
}

export function shortHash(value: string): string {
  return `${value.slice(0, 6)}·${value.slice(-5)}`.toUpperCase();
}
